import styled from "styled-components";
import Col from "../../Shared/Kit/Col";

export const Wrapper = styled(Col)`
    #fullpage .section.active {
        .banner-text span{
            animation: fade-out 1.5s ease both;
        }
        .section-title {
            animation: move-left 1s ease both;
            animation-delay: 0.5s;
        }
        .section-description {
            animation: move-down 1s ease both;
            animation-delay: 0.5s;
        }
        .slider-container {
            animation: zoom-in 1.5s ease both;
            animation-delay: 0.5s;
        }
        .slider-container2 {
            animation: fade-out-2 1s ease both;
            animation-delay: 1.5s;
        }
    }
`